import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import FilterButton from "../../components/Common/FilterButton";
import UserPropertyList from "../../components/UserProperty/UserPropertyList";
import UserPropertyFormModal from "../../components/UserProperty/PropertiesFormModal";
import ListPagination from "../../components/Common/ListPagination";
import CommonStyles from "../../static/styles/common";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as UserPropertyActions from "../../store/actions/UserProperty";
import Permission from "../../components/Common/Permission";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import Button from "sushiweb/Button";
import { isMobile } from "../../utils";

const useStyles = makeStyles((theme) => ({
  actionBar: {
    ...CommonStyles.actionBar,
    "& > button": {
      marginLeft: "20px",
    },
  },
}));

const UserProperties = (props) => {
  const classes = useStyles();
  const [modalState, setModalState] = useState(false);
  const [activeId, setActiveId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const allActions = MenuActionsMappings[MenuNames.USER_PROPERTY];

  const filterFields = ["user_id", "key"];

  const handleClick = (type, id) => {
    setActiveId(id);
    setModalState(type);
  };

  const handleClose = () => {
    setModalState(false);
  };

  //handle pagination
  const handleNavClick = (action) => {
    if (action === "prev") {
      let pageRequest = {
        page: currentPage - 1,
      };
      setCurrentPage(currentPage - 1);
      props.getUserPropertyList(props.activeFilters, pageRequest);
    } else {
      let pageRequest = {
        page: currentPage + 1,
      };
      setCurrentPage(currentPage + 1);
      props.getUserPropertyList(props.activeFilters, pageRequest);
    }
  };

  const getModal = () => {
    switch (modalState) {
      case "Add":
      case "Edit":
        return (
          <UserPropertyFormModal
            activeId={activeId}
            modalState={modalState}
            handleClose={handleClose}
          />
        );
      case "Filter":
        return (
          <UserPropertyFormModal
            activeId={activeId}
            modalState={modalState}
            handleClose={handleClose}
            filterFields={filterFields}
          />
        );
      default:
        return;
    }
  };

  useEffect(() => {
    props.getUserPropertyKeys();
    props.getUserPropertyList({});
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [JSON.stringify(props.activeFilters)]);

  return (
    <UserPropertyViewContainer className="UserProperty-View container">
      <FlexContainer align="flex-start">
        <Heading>Properties</Heading>
        <div className="actionBar mb-20 flex items-center justify-end">
          <Permission requiredPerms={[allActions.READ]}>
            <FilterButton
              activeFilters={props.activeFilters}
              handleClick={() => handleClick("Filter", null)}
            />
          </Permission>
          <Permission requiredPerms={[allActions.CREATE]}>
            <Button
              onClick={() => handleClick("Add", null)}
              className="sushi-btn ml-12"
              data-testid="userpropertyAddNewBtn"
            >
              Add New
            </Button>
          </Permission>
        </div>
      </FlexContainer>
      <UserPropertyList
        userPropertyList={props.userPropertyList}
        handleClick={handleClick}
      />
      <ListPagination
        nextPage={props.nextPage}
        prevPage={props.prevPage}
        handleNavClick={handleNavClick}
      />
      {modalState && getModal()}
    </UserPropertyViewContainer>
  );
};

const UserPropertyViewContainer = styled.div`
  & > div {
    flex-direction: ${isMobile() ? "column" : "row"};
    .actionBar {
      margin-top: ${isMobile() ? "10px" : "unset"};
      margin-left: ${isMobile() ? "unset" : "auto"};
    }
  }
`;

function mapStateToProps(state) {
  const { UserProperty } = state;
  return {
    userPropertyList: UserProperty.userPropertyList,
    nextPage: UserProperty.nextPage,
    prevPage: UserProperty.prevPage,
    activeFilters: UserProperty.activeFilters,
    keysList: UserProperty.keysList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getUserPropertyList: bindActionCreators(
      UserPropertyActions.getUserPropertyList,
      dispatch
    ),
    getUserPropertyKeys: bindActionCreators(
      UserPropertyActions.getUserPropertyKeys,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserProperties);
